export enum MessageShortcutStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
